export const INITIAL_PAGES = {
  page: 1,
  mobilePage: 1
};
